<template>
  <image-cropper-upload :url="media_update_url" @uploaded="handleUploaded">
  </image-cropper-upload>
</template>

<script>
import ImageCropperUpload from "@/components/ImageCropperUpload";

export default {
  components: { ImageCropperUpload },
  data() {
    return {
      media_update_url: Laravel.user.customer_profile.media_update_url
    };
  },
  methods: {
    handleUploaded(media) {
      this.$bus.$emit("media-uploaded", media);
    }
  }
};
</script>
